interface HamburgerProps {
    handleHamburgerClick : () => void
}

export default function Hamburger(props : HamburgerProps): JSX.Element {
  return (
      <div className="z-20 fixed top-[2%] right-[2%]" onClick={(e) => props.handleHamburgerClick()}>
        <img
          className=" w-8 opacity-60 transition duration-300 hover:scale-125 hover:opacity-100"
          src="/res/svgs/hamburger.svg"
        />
    </div>
  );
}
